window.addEventListener('load', () => {
  let isDown = false
  let startX
  let scrollLeft

  const slider = document.querySelector('[data-scroll]')
  const buttonPrev = document.querySelector('[data-prev]')
  const buttonNext = document.querySelector('[data-next]')

  buttonPrev.addEventListener('click', e => {
    e.stopPropagation()
    let interval
    interval = setInterval(() => {
      slider.scrollLeft = slider.scrollLeft - 10
    }, 10)

    setTimeout(() => {
      clearInterval(interval)
    }, 500)
  })

  buttonNext.addEventListener('click', e => {
    e.stopPropagation()
    e.stopPropagation()
    let interval
    interval = setInterval(() => {
      slider.scrollLeft = slider.scrollLeft + 10
    }, 10)

    setTimeout(() => {
      clearInterval(interval)
    }, 500)
  })

  slider.addEventListener('mousedown', e => {
    isDown = true
    slider.classList.add('active')
    startX = e.pageX - slider.offsetLeft
    scrollLeft = slider.scrollLeft
  })
  slider.addEventListener('mouseleave', () => {
    isDown = false
    slider.classList.remove('active')
  })
  slider.addEventListener('mouseup', () => {
    isDown = false
    slider.classList.remove('active')
  })
  slider.addEventListener('mousemove', e => {
    if (!isDown) return
    e.preventDefault()
    const x = e.pageX - slider.offsetLeft
    const walk = (x - startX) * 3
    slider.scrollLeft = scrollLeft - walk
  })
})
